//#region package/makeidx/provides.ts
var macros = {
	see: { signature: "m m" },
	seealso: { signature: "m m" },
	seename: { signature: "m" },
	alsoname: { signature: "m" },
	index: { signature: "m" }
};
var environments = {};
//#endregion
export { environments, macros };

//# sourceMappingURL=index.js.map